module.exports = __webpack_public_path__ + "img/rlsb.d2efe5d5.png";